module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-latin-400-normal.woff2?b009a76ad6afe4ebd301e36f847a29be";